import { render, staticRenderFns } from "./applicant-mail-list-component.vue?vue&type=template&id=27ccee66&"
import script from "./applicant-mail-list-component.vue?vue&type=script&lang=ts&"
export * from "./applicant-mail-list-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports